var _excluded = ["children", "className", "icon", "id", "isAssertive", "tabIndex"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef, useMemo } from 'react';
import classnames from 'classnames';
import StyledFieldError, { StyledFieldErrorIconContainer } from "./styled";
import Text from "../Text";
import { Negative } from "../Icon";
import { FIELD_ERROR } from "../../constants";

/**
 * Displays an error message. Component re-used by most form fields.
 */
var FieldError = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? true : _ref$icon,
    id = _ref.id,
    _ref$isAssertive = _ref.isAssertive,
    isAssertive = _ref$isAssertive === void 0 ? false : _ref$isAssertive,
    tabIndex = _ref.tabIndex,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classNames = useMemo(function () {
    return classnames('csl-field-error', className);
  }, [className]);
  return /*#__PURE__*/React.createElement("div", {
    "aria-live": isAssertive ? 'assertive' : undefined,
    id: id,
    ref: ref,
    tabIndex: tabIndex
  }, Boolean(children) && /*#__PURE__*/React.createElement(StyledFieldError, _extends({
    className: classNames,
    "data-csl-selector": FIELD_ERROR
  }, rest), icon && /*#__PURE__*/React.createElement(StyledFieldErrorIconContainer, {
    className: "csl-field-error__icon-container"
  }, /*#__PURE__*/React.createElement(Negative, {
    color: "critical",
    iconSize: "md",
    size: "s2",
    trim: true
  })), /*#__PURE__*/React.createElement(Text, {
    color: "critical",
    size: "s2"
  }, children)));
});
FieldError.displayName = 'FieldError';
export default FieldError;